import Sidebar from "../DesignSystem/Sidebar";
import "../../css/Recruitment/RecruitmentDashboard.css";
import { Helmet } from "react-helmet-async";
import "../../css/Recruitment/RecruitmentDashboard.css";
import ButtonGreen from "../DesignSystem/Buttons/ButtonGreen";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { useState, useEffect } from "react";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../../backend/firebaseConfig";
import { fetchWithFallback } from "../../utils/fetchWithFallback";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShare,
  faShareFromSquare,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import InputField from "../DesignSystem/Inputs/InputField";

const RecruitmentDashboard = () => {
  const [emailList, setEmailList] = useState([]);
  const [userEnteredEmail, setUserEnteredEmail] = useState("");
  const [selectedEmail, setSelectedEmail] = useState("");
  const [filteredEmails, setFilteredEmails] = useState([]);
  const [selectedAdviserUid, setSelectedAdviserUid] = useState(null);
  const [backupInProgress, setBackupInProgress] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [recruitmentData, setRecruitmentData] = useState([]);
    const [oldEmail, setOldEmail] = useState("");
    const [newEmail, setNewEmail] = useState("");
    const [updateInProgress, setUpdateInProgress] = useState(false);
    const navigate = useNavigate();
    const fetchData = async () => {
      // 1. Get all docs from the top-level "Recruitment" collection
      const recruitmentRef = collection(db, "Recruitment");
      const recruitmentSnapshot = await getDocs(recruitmentRef);

      let allResults = [];

      // 2. For each doc in "Recruitment", fetch the "Personal Details" subcollection
      for (const recruitmentDoc of recruitmentSnapshot.docs) {
        // console.log("Recruitment doc ID:", recruitmentDoc.id);
        // Build a reference to the subcollection named EXACTLY "Personal Details"
        const personalDetailsRef = collection(
          recruitmentDoc.ref,
          "Personal Details",
        );
        const personalDetailsSnapshot = await getDocs(personalDetailsRef);

        // 3. For each doc in "Personal Details", push its data into our array
        personalDetailsSnapshot.forEach((docSnap) => {
          const data = docSnap.data();
          allResults.push({
            forename: data.forename || "",
            surname: data.surname || "",
            email: recruitmentDoc.id || "",
            phoneNumber: data.mobileTelephone || "",
          });
        });
      }

      // Store the combined results in state
      setRecruitmentData(allResults);
    };

    useEffect(() => {
      fetchData();
    }, []);

    const handleClose = () => {
      setIsOpen(false);
    };

    useEffect(() => {
      const fetchEmails = async () => {
        const advisersCollection = collection(db, "Advisers");
        const advisersSnapshot = await getDocs(advisersCollection);

        let emailData = [];

        for (const adviserDoc of advisersSnapshot.docs) {
          const personalDetailsDocRef = doc(
            db,
            `Advisers/${adviserDoc.id}/Personal Details/Data`,
          );

          const personalDetailsSnapshot = await getDoc(personalDetailsDocRef);

          if (personalDetailsSnapshot.exists()) {
            const email = personalDetailsSnapshot.data().emailAddress;
            if (email) {
              emailData.push({ email, uid: adviserDoc.id });
            }
          }
        }

        setEmailList(emailData);
      };

      fetchEmails();
    }, []);

    const handleUserEmailChange = (e) => {
      setUserEnteredEmail(e.target.value.trim());
    };

    const handleSelectInputChange = (e) => {
      setIsOpen(true);
      const value = e.target.value;
      setSelectedEmail(value.trim());

      setFilteredEmails(
        emailList.filter(({ email }) =>
          email.toLowerCase().includes(value.toLowerCase()),
        ),
      );
    };

    const handleEmailSelect = async (email, uid) => {
      setSelectedEmail(email);
      setSelectedAdviserUid(uid);
      setFilteredEmails([]);

      setIsOpen(false);
      // refreshTable();
    };

    const handleBackupData = async () => {
      if (!selectedAdviserUid || !userEnteredEmail) {
        // console.log("Please enter an email and select an adviser.");
        return;
      }

      setBackupInProgress(true);

      try {
        // console.log(
        //   `Fetching Firestore data for: Advisers/${selectedAdviserUid}`
        // );

        // Send a POST request with uid and email
        const response = await fetch(
          "http://localhost:3000/addAdviserToAuthorizedMembers",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              uid: selectedAdviserUid,
              email: userEnteredEmail,
            }),
          },
        );

        if (!response.ok) {
          const err = await response.json().catch(() => ({}));
          // console.error("Failed to add adviser:", err);
        } else {
          const data = await response.json();
          // console.log("Adviser added successfully:", data);
        }

        if (!response.ok) {
          throw new Error("Failed to backup adviser data");
        }

        const result = await response.json();
        // console.log(
        //   "Backup Successful:",
        //   JSON.stringify(result.adviserData, null, 2)
        // );
        // alert("Backup created successfully!");
      } catch (error) {
        // console.error("Error backing up adviser data:", error);
        // alert("Backup failed.");
      } finally {
        setBackupInProgress(false);
      }
    };

    const handleUpdateEmail = async () => {
      if (!oldEmail || !newEmail) {
        alert("Please enter both old and new email addresses.");
        return;
      }

      setUpdateInProgress(true);

      try {
        const response = await fetch(
          "http://localhost:3000/updateAuthorizedMemberEmail",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              oldEmail: oldEmail,
              newEmail: newEmail,
            }),
          },
        );

        if (!response.ok) {
          const err = await response.json().catch(() => ({}));
          alert(`Failed to update email: ${err.error || "Unknown error"}`);
          return;
        }

        const result = await response.json();
        alert(`Email updated successfully from ${oldEmail} to ${newEmail}`);
        setOldEmail("");
        setNewEmail("");
      } catch (error) {
        console.error("Error updating email:", error);
        alert("Failed to update email.");
      } finally {
        setUpdateInProgress(false);
      }
    };

    return (
      <div className="Main-Page">
        <Sidebar />
        <Helmet>
          <title>Recruitment Dashboard</title>
          <meta
            name="description"
            content="Recruitment Dashboard for managing and tracking recruitment activities."
          />
        </Helmet>
        <div className="Main-Container">
          <h2>Recruitment Dashboard</h2>
          {/* <MapAdviser /> */}
          <div className="RecruitmentDashboardColumn">
            <div className="RecruitmentDashboardRow">
              <InputField
                type="text"
                title="Enter Adviser Email"
                value={userEnteredEmail}
                onChange={handleUserEmailChange}
                placeholder="Enter an email manually"
              />

              <div style={{ position: "relative" }}>
                <InputField
                  type="text"
                  title="Select Adviser Email"
                  value={selectedEmail}
                  onChange={handleSelectInputChange}
                  placeholder="Pick an email from the list"
                />
                {isOpen && (
                  <div className="AdviserPickUpDropDown">
                    <CloseIcon className="CloseIcon" onClick={handleClose} />
                    {filteredEmails.length > 0 &&
                      filteredEmails.map(({ email, uid }) => (
                        <div
                          className="Content"
                          key={uid}
                          onClick={() => handleEmailSelect(email, uid)}
                        >
                          {email}
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
            <ButtonGreen
              onClick={handleBackupData}
              buttonText={backupInProgress ? "Adding..." : "Add Adviser"}
              disabled={!selectedAdviserUid || backupInProgress}
            />
          </div>

          <div
            className="RecruitmentDashboardColumn"
            style={{ marginTop: "40px" }}
          >
            <h3>Update Authorized Member Email</h3>
            <div className="RecruitmentDashboardRow">
              <InputField
                type="text"
                title="Old Email Address"
                value={oldEmail}
                onChange={(e) => setOldEmail(e.target.value.trim())}
                placeholder="Enter current email address"
              />
              <InputField
                type="text"
                title="New Email Address"
                value={newEmail}
                onChange={(e) => setNewEmail(e.target.value.trim())}
                placeholder="Enter new email address"
              />
            </div>
            <ButtonGreen
              onClick={handleUpdateEmail}
              buttonText={updateInProgress ? "Updating..." : "Update Email"}
              disabled={!oldEmail || !newEmail || updateInProgress}
            />
          </div>

          <table style={{ marginTop: "20px" }}>
            <thead>
              <tr>
                <th></th>
                <th>
                  <div className="Content-Large">Adviser Name</div>
                </th>
                <th>
                  <div className="Content-Large">Adviser Email</div>
                </th>
                <th>
                  <div className="Content-Large">Adviser Phone</div>
                </th>
                <th>
                  <div className="Content-Large">Request Agency Codes</div>
                </th>
                <th>
                  <div className="Content-Large">Request References</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {recruitmentData.map((item, index) => (
                <tr key={index}>
                  <td>
                    <div className="Content">{index + 1}.</div>
                  </td>
                  <td>
                    <div className="Content-SemiBold">
                      {item.forename} {item.surname}
                    </div>
                  </td>
                  <td>
                    <a href={`mailto:${item.email}`}>
                      <div className="Content">{item.email}</div>
                    </a>
                    {/* <FontAwesomeIcon icon={faShare} className="view-icon" /> */}
                  </td>
                  <td>
                    {/* <FontAwesomeIcon
                         icon={faShareFromSquare}
                         className="files-icon"
                       /> */}
                    <a href={`tel:${item.phoneNumber}`}>
                      <div className="Content">+{item.phoneNumber}</div>
                    </a>
                  </td>
                  <td>
                    <FontAwesomeIcon
                      icon={faShare}
                      className="view-icon"
                      onClick={() => {
                        navigate(
                          `/RecruitmentDashboard/RequestAgencyCodes/${item.email}`,
                          // {
                          //   state: { name: `${item.forename} ${item.surname}` },
                          // }
                        );
                      }}
                    />
                  </td>
                  <td>
                    <FontAwesomeIcon
                      icon={faShareFromSquare}
                      className="files-icon"
                      onClick={() => {
                        navigate(
                          `/RecruitmentDashboard/RequestReferences/${item.email}`,
                          // {
                          //   state: { name: `${item.forename} ${item.surname}` },
                          // }
                        );
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
};
export default RecruitmentDashboard;
